import React from 'react';
import './SubmitButton.scss';

const SubmitButton = (props: any) => {
  const { block, className, text, ...rest } = props
  const classes = 'button-submit-component' + (block ? ' button-block' : '');
  return (
    <button {...rest} className={classes}>
      <span className="button-text">{props.text}</span>
    </button>
  );
}

export default SubmitButton;
